import React from "react";

export default function LoadingScreen(props) {
    return (
        <header className="App-header">{props.message}</header>
    );
}
